import React, { ReactNode } from "react";

import cn from "classnames";

import ButtonLink from "@app/component/ButtonLink";

import styles from "./ShapeKey.module.scss";

interface Props {
  actionName?: ReactNode;
  children: ReactNode;
  contentClassName?: string;
  onAction?: () => void;
}

const ShapeKey: React.FC<Props> = ({ actionName, children, contentClassName, onAction }) => {
  return (
    <div className={styles.container}>
      {actionName && onAction && (
        <div className={styles.header}>
          <ButtonLink onClick={onAction}>{actionName}</ButtonLink>
        </div>
      )}
      <div className={cn(styles.list, contentClassName)}>{children}</div>
    </div>
  );
};

export default ShapeKey;
